import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { FundInadequacyIconProps } from './FundInadequacyIcon';
import { StylesIndexInjections   } from 'common-react';

const getIconSize = ({ variant }: FundInadequacyIconProps) => {
  switch (variant) {
    case 'small':
      return 16;
    case 'small-circle':
      return 24;
    case 'big':
    default:
      return '55%';
  }
};

const getSize = ({ variant }: FundInadequacyIconProps) => {
  switch (variant) {
    case 'small':
      return '16px';
    case 'big':
      return '40px';
    case 'small-circle':
    default:
      return '24px';
  }
};

const getMobileSize = ({ variant }: FundInadequacyIconProps) => {
  switch (variant) {
    case 'small':
      return '24px';
    case 'big':
      return '32px';
    case 'small-circle':
    default:
      return '24px';
  }
};

export default makeUiStyles((theme: Theme) => createStyles({
  root: {},
  titleWrapper: {
    '& > div': {
      [theme.breakpoints.down('sm')]: {
        marginBottom: 6,
      },
    }
  },
  icon: {
    width: getSize,
    height: getSize,
    textAlign: 'center',
    lineHeight: getSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: getMobileSize,
      height: getMobileSize,
      lineHeight: getMobileSize,
    },
    '& > svg': {
      width: getIconSize,
      height: getIconSize,
      [theme.breakpoints.down('sm')]: {
        width: getMobileSize,
        height: getMobileSize,
      },
      '& path:first-of-type': {
        fill: theme.color.reds[100],
      },
    },
  },
}), { name: 'FundInadequacyIcon', index: StylesIndexInjections.UI_MOLECULES });
